import useEventProgram from "../../hooks/useEventProgram";
import AlphabetFilter from "../../../AlphabetFilter";
import { useState } from "react";
import { v4 as uuidv4 } from 'uuid';
import {useTranslation} from "react-i18next";
import {Link} from "react-router-dom";

const contentExtractor = (item) => item.lastName[0].toLowerCase();

export default function Speakers({ id }) {
    const { t } = useTranslation();
    const [programData] = useEventProgram(id);
    const [filter, setFilter] = useState({
        byLetter: '',
    });
    const updateLetterFilter = (value) => {
        setFilter({...filter, byLetter: value});
    }

    if (!programData) {
        return null;
    }

    const authors = Object.values(programData.authors);
    const authorsList = authors.filter(item => {
        return (filter.byLetter === '' || item.lastName[0].toLowerCase() === filter.byLetter.toLowerCase());
    });

    return (
        <div className="tab-panel active" id="authors">
            <div className="authors-list">
                <AlphabetFilter
                    list={authors}
                    contentExtractor={contentExtractor}
                    notifyChange={updateLetterFilter}
                />
                <div className="authors-grid">
                    {
                        authorsList.map(author =>
                            <Link to={`/conference/${id}/speakers/${author.id}`} key={uuidv4()} className="flex-center author-block">
                                <div className="author-photo">
                                    {author.image ? <img src={author.image} className="img-fill" alt="" /> : null}
                                </div>
                                <div className="author-content speaker-content">
                                    <p className="name">{ author.lastName } { author.firstName } { author.middleName }</p>
                                    <p>{author.workplace}</p>
                                    <p>{t('conferences.conference.reportCount')} {author.reportCount}</p>
                                </div>
                            </Link>
                        )
                    }
                </div>
            </div>
        </div>

    )
}
